import { render } from "./BindAlipay.vue?vue&type=template&id=b362774a&scoped=true"
import script from "./BindAlipay.vue?vue&type=script&lang=js"
export * from "./BindAlipay.vue?vue&type=script&lang=js"

import "./BindAlipay.vue?vue&type=style&index=0&id=b362774a&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b362774a"]])

export default __exports__